import { Component, OnInit } from '@angular/core';
import { PersonResponse } from 'src/app/interfaces/person-response';
import { PeliculasService } from 'src/app/services/peliculas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { KnownFor, MoviesByActorResponse } from 'src/app/interfaces/moviesbyactor-response';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-actor',
  templateUrl: './actor.component.html',
  styleUrls: ['./actor.component.css']
})
export class ActorComponent implements OnInit {

  public actor!: PersonResponse;
  public actorMovies: KnownFor[] = [];
  public name!: string;

  constructor(private peliculasService: PeliculasService,
              private router: Router,
              private location: Location,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    const id = this.activatedRoute.snapshot.params.id;

    this.peliculasService.getPerson( id ).subscribe( resp => {
      // console.log(resp);
      if ( !resp ){
        this.router.navigateByUrl('/home');
        return;
      }
      this.actor = resp;
      this.name = resp.name;
      // console.log(this.name);

      this.peliculasService.getMoviesByActor( this.name )
      .subscribe( (resp: any) => {
        // console.log(resp);
        this.actorMovies = resp[0].known_for;
        // console.log(this.actorMovies);
      });
    });
  }

  onRegresar(): void{
    this.location.back();
  }

  onMovieClick( id: number): void{
    this.router.navigate(['/pelicula', id]);
  }


}
